export default __webpack_public_path__ + "static/tooltip-truncation-do-dark-979d035572e1f062adf17f763c5af49440e0d06b838ca3a2e426349a3c8666e9.png";